import { Button, Stack, TextField } from "@mui/material";
import { TableCellInputType } from "@components/data-table/types";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { FilterType } from "@components/data-table/types";
import { OutlinedSelect } from "@components/outlined-select";
import { WpBoolean } from "@hooks/use-config/types";
import { OutlinedDatePicker } from "@components/date-picker";

const booleanBtnSize = 40;
const booleanBtnStyles = {
  borderRadius: 50,
  p: 0,
  width: booleanBtnSize,
  height: booleanBtnSize,
  minWidth: "auto",
};


type TableCellInputProps = {
  currentInputType: TableCellInputType;
  value: string | number | null;
  setValue: (value: string) => void;
  minWidth: number | string;
  maxWidth?: number | string;
  filterType?: FilterType;
  options?: (string | { value: string | number; label: string })[];
  label?: string;
  endValue?: string | number | null;
  setEndValue?: (value: string) => void;
  placeholder?: string;
};

export const DataTableCellInput = ({
  currentInputType,
  value,
  setValue,
  minWidth,
  maxWidth = "180px",
  filterType,
  options,
  label = "Filter Value",
  endValue,
  setEndValue,
}: TableCellInputProps) => {
  if (filterType === FilterType.isSet || filterType === FilterType.isNotSet) {
    return null;
  }
  return (
    <>
      {[TableCellInputType.Select, TableCellInputType.UserInput].includes(
        currentInputType
      ) && (
        <OutlinedSelect
          label={label}
          value={(value ?? "") as string} // convert null to empty string for the select value
          onChange={setValue}
          options={options || []} // pass options if available
          wrapperSx={{
            minWidth,
            maxWidth: minWidth,
          }}
        />
      )}

      {[
        TableCellInputType.Text,
        TableCellInputType.SystemProvided,
        TableCellInputType.MultiLine,
      ].includes(currentInputType) && (
        <TextField
          size="small"
          variant="outlined"
          value={value ?? ""}
          onChange={(e) => setValue(e.target.value)}
          label={label}
          sx={{ minWidth }}
        />
      )}

      {currentInputType === TableCellInputType.Boolean && (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Button
            sx={booleanBtnStyles}
            variant={value === WpBoolean.NO || value === undefined || value === '-' ? "contained" : "text"}
            onClick={() => setValue(WpBoolean.NO)}
            color="error"
          >
            <CloseIcon />
          </Button>
          {/* <Switch
            size="medium"
            checked={!!value}
            onChange={(e) => setFilterValue(!filterValue)}
          /> */}
          <Button
            sx={booleanBtnStyles}
            variant={value === WpBoolean.YES ? "contained" : "text"}
            onClick={() => setValue(WpBoolean.YES)}
            color="success"
          >
            <CheckIcon />
          </Button>
        </Stack>
      )}

      {[TableCellInputType.Date, TableCellInputType.DateTime].includes(
        currentInputType
      ) && (
        <div style={{ display: "inline-flex", gap: "8px"}}>
          <OutlinedDatePicker
            value={value as string | null}
            onChange={(date) => setValue(date as string)}
            label={label}
          />
          {setEndValue && (
            <OutlinedDatePicker
              value={endValue as string | null}
              onChange={(date) => setEndValue(date as string)}
              label={label}
            />
          )}
        </div>
      )}
    </>
  );
};

export const DataTableCellFormInput = ({
  id,
  inputProps,
}: {
  id: string;
  inputProps: TableCellInputProps[];
}) => {
  return (
    <>
      {inputProps.map((inputProp, index) => {
        return <DataTableCellInput key={`${id}-${index}`} {...inputProp} />;
      })}
    </>
  );
};

export default DataTableCellInput;
